import { createFileRoute } from '@tanstack/react-router'

import PageChangelog from '@/pages/PageChangelog'

export const Route = createFileRoute('/settings/changelog')({
  component: PageChangelog
})
